import { render, staticRenderFns } from "./UpsertCustomTargetingForm.vue?vue&type=template&id=ea399f5c&scoped=true"
import script from "./UpsertCustomTargetingForm.vue?vue&type=script&lang=js"
export * from "./UpsertCustomTargetingForm.vue?vue&type=script&lang=js"
import style0 from "./UpsertCustomTargetingForm.vue?vue&type=style&index=0&id=ea399f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea399f5c",
  null
  
)

export default component.exports